import { connect } from 'react-redux';
import { getPublicSession } from '../../publicSession/selectors';
import { attemptSocialLogin } from '../redux/actions';
const mapStateToProps = (state)=>{
    var _getPublicSession_appIds;
    return {
        clientId: ((_getPublicSession_appIds = getPublicSession(state).appIds) === null || _getPublicSession_appIds === void 0 ? void 0 : _getPublicSession_appIds.googleClientId) || ''
    };
};
const mapDispatchToProps = {
    attemptSocialLogin
};
export default connect(mapStateToProps, mapDispatchToProps);
